import { UserFromRequest, UserPermission } from "./userManagement.types";

export const PERMISSION_TO_LABEL_MAP: Record<UserPermission, string> = {
  [UserPermission.CanAccessApp]: "Acesso App Views",
  [UserPermission.CanAccessPortal]: "Acesso Portal Views Manejo",
  [UserPermission.FinalStock]: "Estoque Final",
  [UserPermission.ImportMaps]: "Importar mapas",
  [UserPermission.ExportAndImportPastureCSV]: "Exportar/Importar CSV pasto",
  [UserPermission.RegisterForageCycle]: "Cadastrar ciclo de forragems",
  [UserPermission.CanAccessBenchmark]: "Acesso ao Benchmark",
};

export function hasPermission(
  permission: UserPermission,
  userPermissions: UserFromRequest["permissoes"] = [],
): boolean {
  const permissionName = PERMISSION_TO_LABEL_MAP[permission];

  if (!permissionName || userPermissions.length === 0) {
    return false;
  }

  return userPermissions.some(
    (p) => p.nome.toLowerCase() === permissionName.toLowerCase(),
  );
}
